import {Component, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, UrlSegment} from "@angular/router";
import {ContactCategory} from "./contacts-list.component";
import {get_person} from "./graphql/getContacts";
import {Apollo} from "apollo-angular";
import {ContactsService} from "./contacts.service";
import {DataFormatService} from "../services/data-format.service";
import {MatTableDataSource} from "@angular/material/table";
import {Employee} from "../interfaces/employee";
import {DatePipe} from "@angular/common";
import EntityAddress from "../interfaces/entity-address";
import {DateTimeService} from "../services/date-time.service";
import {PageEvent} from "@angular/material/paginator";

interface AttendedEventsTable {
  name: string
  url: string
  start_date: string
  end_date: string
  is_registered: boolean
}
interface EmployeeTable {
  name: string
  url: string
  title: string | null
  phone: string | null
  email: string | null
}
@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContactsComponent {

  public contactType: ContactCategory
  public contactId: string | null;
  public contact: object | null

  public employeesColumns: string[] = ['name', 'title', 'phone', 'email']
  public employeeDataSource : MatTableDataSource<EmployeeTable>

  public companyEventColumns: string[] = ['name', 'date', 'registered']
  public companyEventDataSource: MatTableDataSource<AttendedEventsTable>

  public showDeals: boolean = true;
  public showDeadDeals: boolean = false;
  public showSponsorDeals: boolean = false;
  public showDeadSponsorDeals: boolean = false;
  constructor(private route: ActivatedRoute, public contactService: ContactsService, public dataFormat: DataFormatService, public datePipe: DatePipe, private dateTimeFormat: DateTimeService) {
  }

  ngOnInit(){
    this.contactId = this.route.snapshot.paramMap.get('id') ?? null
    this.route.snapshot.url.filter((seg:UrlSegment) => {
      if(seg.path === ContactCategory.PEOPLE){
        this.contactType = ContactCategory.PEOPLE
      }
      if(seg.path === ContactCategory.ORGANIZATIONS){
        this.contactType = ContactCategory.ORGANIZATIONS
      }
      if(seg.path === ContactCategory.SPONSORS){
        this.contactType = ContactCategory.SPONSORS
      }
    });

    this.contactService.getContact(this.contactType, this.contactId, new PageEvent())
    this.getCompanyEventsSource()

  }

  public getEmployeeSource(){
    let data:EmployeeTable[] = []
    this.contactService.organization$.subscribe((result) => {
      let sortedEmployees = [...result?.employees ?? []]?.sort((a,b) => {
        let nameA = a.person.name ?? ""
        let nameB = b.person.name ?? ""
        return nameA.localeCompare(nameB)
      })
      sortedEmployees.forEach((employee:Employee) => {
        let email = employee.person.entity.entityEmailAddresses[0]?.emailAddress?.emailaddress

        let tableData: EmployeeTable = {
          name: employee.person.name,
          url: this.dataFormat.formatLink(employee.person),
          title: employee.title,
          phone: employee.person.entity.entityPhoneNumbers.length > 0 ?
            this.dataFormat.phoneFormat(
              employee.person.entity.entityPhoneNumbers[0]?.phoneNumber.area_code,
              employee.person.entity.entityPhoneNumbers[0]?.phoneNumber.phone_number
            ): null,
          email: email
        }
        data.push(tableData)
      })
    })
    this.employeeDataSource = new MatTableDataSource(data)
    return this.employeeDataSource
  }

  public getCompanyEventsSource(){
    let data:AttendedEventsTable[] = []
    this.contactService.companyEvents$.subscribe((result) => {
      let sortedEvents = [...result].sort((a,b) => {
        let dateA = a.companyEvent.companyEventDates[0].start_date ?? ""
        let dateB = b.companyEvent.companyEventDates[0].start_date ?? ""
        return dateA.localeCompare(dateB)
      })
      sortedEvents.forEach((event:any) => {
        let currentDay = this.datePipe.transform(new Date(), 'yyyy-MM-dd')
        if(!!currentDay && event.companyEvent.companyEventDates[0].start_date >= currentDay){
          let tableData:AttendedEventsTable = {
            name: event.companyEvent.title,
            url: this.dataFormat.formatLink(event.companyEvent),
            start_date: "",
            end_date: "",
            is_registered: event.is_registered
          }
          if(event.companyEvent.companyEventDates[0].start_date!==null){
            tableData.start_date += event.companyEvent.companyEventDates[0].start_date
          }
          if(event.companyEvent.companyEventDates[0].start_time!==null){
            tableData.start_date += " " + event.companyEvent.companyEventDates[0].start_time
            tableData.start_date = event.companyEvent.companyEventDates[0].start_date + " " + this.dateTimeFormat.formatUTCTime(new Date(tableData.start_date), event.companyEvent.companyEventDates[0].timezone)
          }
          if(event.companyEvent.companyEventDates[0].end_date!==null){
            tableData.end_date += event.companyEvent.companyEventDates[0].end_date
          }
          if(event.companyEvent.companyEventDates[0].end_time!==null){
            tableData.end_date += " " + event.companyEvent.companyEventDates[0].end_time
            tableData.end_date = event.companyEvent.companyEventDates[0].end_date + " " + this.dateTimeFormat.formatUTCTime(new Date(tableData.end_date), event.companyEvent.companyEventDates[0].timezone)
          }
          data.push(tableData)
        }
      })
    })
    this.companyEventDataSource = new MatTableDataSource(data)
    return this.companyEventDataSource
  }

  public renderAddress(address: EntityAddress){
    let addressString = address.address.address1
    if(address.address.address2!==null){
      addressString = addressString + ", " + address.address.address2
    }
    addressString = addressString + ", " + address.address.zipCode.city + ", " + address.address.zipCode.state.abbreviation + " "
    + address.address.zipCode.zipcode
    return addressString
  }

  public toggleView(type:string){
    if(type=='deal'){
      this.showDeals = !this.showDeals
    }
    if(type=='dead'){
      this.showDeadDeals = !this.showDeadDeals
    }
    if(type=='sponsor'){
      this.showSponsorDeals = !this.showSponsorDeals
      let length = 0;
      this.contactService.sponsorDeals$.subscribe((result) => length = result.length)
      if(this.showSponsorDeals && length==0){
        this.contactService.getSponsorAssociatedDeals(this.contactId, new PageEvent())
      }
    }
    if(type=='deadSponsor'){
      this.showDeadSponsorDeals = !this.showDeadSponsorDeals
      let length = 0;
      this.contactService.deadSponsorDeals$.subscribe((result) => length = result.length)
      if(this.showDeadSponsorDeals && length==0){
        this.contactService.getSponsorAssociatedDeals(this.contactId, new PageEvent())
      }
    }
  }

  public getPage(event: PageEvent){
    this.contactService.getContact(this.contactType, this.contactId, event)
  }

  public getAssociatedDealsPage(event: PageEvent){
    this.contactService.getSponsorAssociatedDeals(this.contactId, event)
  }

  protected readonly ContactCategory = ContactCategory;
}
